<template>
    <div class="d-flex justify-center align-center">
        <div v-for="media in socialMedia" :key="media.id">
            <v-btn v-if="includePropec && !media.icon.includes('mdi-')" :class="propecLogoClass" :href="media.url" target="_blank" dark icon width="22px" height="22px">
                <v-img style="height: 22px; width: 22px" :src="logoUrl"></v-img>
            </v-btn>

            <v-btn v-else-if="media.icon.includes('mdi-')" :class="iconClass" :href="media.url" target="_blank" data-cy="social-media-icon" dark icon>
                <v-icon size="24px">
                    {{ media.icon }}
                </v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        socialMedia: [],

        includePropec: {
            type: Boolean,
            default: true,
        },

        propecLogoClass: String,
        iconClass: String,
    },

    data: () => ({
        logoUrl: '/storage/assets/footer/footer_logo.png',
    }),
};
</script>
